import { Checkbox } from '../../ui/checkbox';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';
import { Label } from '../../ui/label';
import FieldError from '../FieldError';
import { LOSS_TYPES } from '../intakeConstants';

export default function LossTypeStep({ formData, errors, handleChange, onToggleLossType, clearError }) {
  return (
    <div>
      <label className="text-blue-500 text-2xl font-bold mb-6 block">Select Type(s) Of Loss</label>
      <div className="space-y-4 mb-4">
        {LOSS_TYPES.map((type) => (
          <div key={type} className="flex items-center space-x-3">
            <Checkbox
              id={type}
              checked={formData.lossTypes.includes(type)}
              onCheckedChange={() => { onToggleLossType(type); if (errors.lossTypes) clearError('lossTypes'); }}
              className="w-6 h-6 border-2"
            />
            <Label htmlFor={type} className="text-xl text-gray-600 cursor-pointer">
              {type}
            </Label>
          </div>
        ))}
      </div>
      <FieldError message={errors.lossTypes} className="mb-4" />

      <div className="mt-8">
        <Label className="text-lg text-gray-500 mb-4 block">Fault Of Driver</Label>
        <RadioGroup value={formData.faultOfDriver} onValueChange={(v) => handleChange('faultOfDriver', v)}>
          <div className="flex flex-wrap gap-4 md:gap-8">
            {[
              { v: 'At Fault', id: 'at-fault' },
              { v: 'Not At Fault', id: 'not-fault' },
              { v: 'Unknown', id: 'unknown' },
            ].map((opt) => (
              <div key={opt.id} className="flex items-center space-x-3">
                <RadioGroupItem value={opt.v} id={opt.id} className="w-6 h-6" />
                <Label htmlFor={opt.id} className="text-xl text-gray-600 cursor-pointer">{opt.v}</Label>
              </div>
            ))}
          </div>
        </RadioGroup>
        <FieldError message={errors.faultOfDriver} />
      </div>
    </div>
  );
}
